/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "web_services/candidate_experience/proto/page.proto" (package "applied.candidate_experience", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message applied.candidate_experience.HeaderTemplate
 */
export interface HeaderTemplate {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string subtitle = 2;
     */
    subtitle: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.ParagraphTemplate
 */
export interface ParagraphTemplate {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.PageTemplate
 */
export interface PageTemplate {
    /**
     * @generated from protobuf oneof: templates
     */
    templates: {
        oneofKind: "headerTemplate";
        /**
         * @generated from protobuf field: applied.candidate_experience.HeaderTemplate header_template = 1;
         */
        headerTemplate: HeaderTemplate;
    } | {
        oneofKind: "paragraphTemplate";
        /**
         * @generated from protobuf field: applied.candidate_experience.ParagraphTemplate paragraph_template = 2;
         */
        paragraphTemplate: ParagraphTemplate;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message applied.candidate_experience.PageData
 */
export interface PageData {
    /**
     * @generated from protobuf field: repeated applied.candidate_experience.PageTemplate templates = 1;
     */
    templates: PageTemplate[];
}
/**
 * @generated from protobuf message applied.candidate_experience.CreatePageResponse
 */
export interface CreatePageResponse {
    /**
     * @generated from protobuf field: string page_uuid = 1;
     */
    pageUuid: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class HeaderTemplate$Type extends MessageType<HeaderTemplate> {
    constructor() {
        super("applied.candidate_experience.HeaderTemplate", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subtitle", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HeaderTemplate>): HeaderTemplate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.subtitle = "";
        if (value !== undefined)
            reflectionMergePartial<HeaderTemplate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HeaderTemplate): HeaderTemplate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* string subtitle */ 2:
                    message.subtitle = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HeaderTemplate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* string subtitle = 2; */
        if (message.subtitle !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subtitle);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.HeaderTemplate
 */
export const HeaderTemplate = new HeaderTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParagraphTemplate$Type extends MessageType<ParagraphTemplate> {
    constructor() {
        super("applied.candidate_experience.ParagraphTemplate", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ParagraphTemplate>): ParagraphTemplate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial<ParagraphTemplate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParagraphTemplate): ParagraphTemplate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParagraphTemplate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.ParagraphTemplate
 */
export const ParagraphTemplate = new ParagraphTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageTemplate$Type extends MessageType<PageTemplate> {
    constructor() {
        super("applied.candidate_experience.PageTemplate", [
            { no: 1, name: "header_template", kind: "message", oneof: "templates", T: () => HeaderTemplate },
            { no: 2, name: "paragraph_template", kind: "message", oneof: "templates", T: () => ParagraphTemplate }
        ]);
    }
    create(value?: PartialMessage<PageTemplate>): PageTemplate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.templates = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<PageTemplate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageTemplate): PageTemplate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* applied.candidate_experience.HeaderTemplate header_template */ 1:
                    message.templates = {
                        oneofKind: "headerTemplate",
                        headerTemplate: HeaderTemplate.internalBinaryRead(reader, reader.uint32(), options, (message.templates as any).headerTemplate)
                    };
                    break;
                case /* applied.candidate_experience.ParagraphTemplate paragraph_template */ 2:
                    message.templates = {
                        oneofKind: "paragraphTemplate",
                        paragraphTemplate: ParagraphTemplate.internalBinaryRead(reader, reader.uint32(), options, (message.templates as any).paragraphTemplate)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageTemplate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* applied.candidate_experience.HeaderTemplate header_template = 1; */
        if (message.templates.oneofKind === "headerTemplate")
            HeaderTemplate.internalBinaryWrite(message.templates.headerTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.ParagraphTemplate paragraph_template = 2; */
        if (message.templates.oneofKind === "paragraphTemplate")
            ParagraphTemplate.internalBinaryWrite(message.templates.paragraphTemplate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.PageTemplate
 */
export const PageTemplate = new PageTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageData$Type extends MessageType<PageData> {
    constructor() {
        super("applied.candidate_experience.PageData", [
            { no: 1, name: "templates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PageTemplate }
        ]);
    }
    create(value?: PartialMessage<PageData>): PageData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.templates = [];
        if (value !== undefined)
            reflectionMergePartial<PageData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageData): PageData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated applied.candidate_experience.PageTemplate templates */ 1:
                    message.templates.push(PageTemplate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated applied.candidate_experience.PageTemplate templates = 1; */
        for (let i = 0; i < message.templates.length; i++)
            PageTemplate.internalBinaryWrite(message.templates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.PageData
 */
export const PageData = new PageData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePageResponse$Type extends MessageType<CreatePageResponse> {
    constructor() {
        super("applied.candidate_experience.CreatePageResponse", [
            { no: 1, name: "page_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreatePageResponse>): CreatePageResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageUuid = "";
        if (value !== undefined)
            reflectionMergePartial<CreatePageResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePageResponse): CreatePageResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string page_uuid */ 1:
                    message.pageUuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePageResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string page_uuid = 1; */
        if (message.pageUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pageUuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CreatePageResponse
 */
export const CreatePageResponse = new CreatePageResponse$Type();
